import { KeycloakService } from "keycloak-angular";
import type { IEnvironment } from "../models/interfaces/environment.interface";

function addResourceHint(rel: "dns-prefetch" | "preconnect", href: string): void {
  if (!href.startsWith("http://") && !href.startsWith("https://")) {
    return;
  }

  const origin = new URL(href).origin;
  const selector = `link[rel="${rel}"][href="${origin}"]`;

  if (document.head.querySelector(selector)) {
    return;
  }

  const link = document.createElement("link");
  link.rel = rel;
  link.href = origin;

  if (rel === "preconnect") {
    link.crossOrigin = "anonymous";
  }

  document.head.appendChild(link);
}

function addAuthResourceHints(environment: IEnvironment): void {
  [environment.BASE_URL, environment.KEYCLOAK.URL].forEach((href: string) => {
    addResourceHint("dns-prefetch", href);
    addResourceHint("preconnect", href);
  });
}

export function keycloakInitializer(keycloakService: KeycloakService, environment: IEnvironment): () => Promise<boolean> {
  return (): Promise<boolean> => {
    addAuthResourceHints(environment);

    return keycloakService.init({
      config: {
        url: environment.KEYCLOAK.URL,
        realm: environment.KEYCLOAK.REALM,
        clientId: environment.KEYCLOAK.CLIENT_ID,
      },
      enableBearerInterceptor: false,
      initOptions: {
        onLoad: "check-sso",
        silentCheckSsoRedirectUri: window.location.origin + "/assets/silent-check-sso.html",
        silentCheckSsoFallback: false,
        checkLoginIframe: false,
        messageReceiveTimeout: 3000,
        pkceMethod: "S256",
      },
      loadUserProfileAtStartUp: false,
    });
  };
}
